/* eslint-disable react-refresh/only-export-components */
import React from "react";
import { createBrowserRouter, Navigate } from "react-router";

import { Layout } from "~/components/Layout";

import WelcomePage from "~/pages/Welcome/Welcome";
import TrendingPage from "~/pages/Trending/TrendingPage";
import { trendingLoader } from "~/pages/Trending/trending.loader";
import MarketPage from "~/pages/Market/Market";
import TradePage from "~/pages/Trade/Trade";
import RebatePage from "~/pages/Rebate";
import BalancePage from "~/pages/Balance/BalancePage";
import KDetailPage from "~/pages/KDetail";
import QuickBuyPage from "~/pages/QuickBuy/Page";
import GoOfflinePage from "~/pages/GoOffline/Page";
import { rebateLoader } from "~/pages/Rebate/rebate.loader";
import { tokenSearchLoader } from "~/pages/TokenSearch/loader";

const LazySearchPage = React.lazy(() => import("~/pages/TokenSearch/Page"));
const LazyIdentifyPage = React.lazy(() => import("~/pages/TokenIdentify/Page"));
const LazyTokenSharePage = React.lazy(() => import("~/pages/TokenShare/Page"));
const LazyTradeConfirmPage = React.lazy(() => import("~/pages/Trade/Confirm"));
const LazyTradeDetailPage = React.lazy(() => import("~/pages/Trade/Detail"));
const LazyProfitTipsPage = React.lazy(() => import("~/pages/ProfitTips/Page"));
const LazyTradeSettingsPage = React.lazy(
    () => import("~/pages/Trade/Setting/TradeSettings")
);
const LazyRebateWithdrawPage = React.lazy(
    () => import("~/pages/Rebate/Withdraw")
);

const LazyWithdrawConfirm = React.lazy(
    () => import("~/pages/Rebate/Withdraw/WithdrawConfirm")
);

const LazyWithdrawHistory = React.lazy(
    () => import("~/pages/Rebate/Withdraw/WithdrawHistory")
);

const LazySettingPage = React.lazy(() => import("~/pages/Setting/Setting"));

export const createRouter = (isNewUser: boolean) =>
    createBrowserRouter(
        isNewUser
            ? [{ path: "*", element: <WelcomePage /> }]
            : [
                  {
                      path: "/",
                      element: <GoOfflinePage />, //<Layout />,
                      children: [
                          {
                              path: "/",
                              element: <TrendingPage />,
                              loader: trendingLoader,
                          },
                          {
                              path: "/market",
                              element: <MarketPage />,
                              loader: tokenSearchLoader,
                          },
                          { path: "/trade", element: <TradePage /> },
                          {
                              path: "/rebate",
                              element: <RebatePage />,
                              loader: rebateLoader,
                          },
                          { path: "/balance", element: <BalancePage /> },
                          { path: "/k-detail", element: <KDetailPage /> },
                          { path: "/quick-buy", element: <QuickBuyPage /> },
                          {
                              path: "/token-search",
                              element: <LazySearchPage />,
                              loader: tokenSearchLoader,
                          },
                          {
                              path: "/token-identify",
                              element: <LazyIdentifyPage />,
                          },
                          {
                              path: "/token-share",
                              element: <LazyTokenSharePage />,
                          },
                          {
                              path: "/trade-confirm",
                              element: <LazyTradeConfirmPage />,
                          },
                          {
                              path: "/trade-detail",
                              element: <LazyTradeDetailPage />,
                          },
                          {
                              path: "/trade-settings",
                              element: <LazyTradeSettingsPage />,
                          },
                          {
                              path: "/rebate-withdraw",
                              element: <LazyRebateWithdrawPage />,
                          },
                          {
                              path: "/withdraw-confirm",
                              element: <LazyWithdrawConfirm />,
                          },
                          {
                              path: "/withdraw-history",
                              element: <LazyWithdrawHistory />,
                          },
                          {
                              path: "/profit-tips",
                              element: <LazyProfitTipsPage />,
                          },
                          { path: "/setting", element: <LazySettingPage /> },
                          { path: "*", element: <Navigate to="/" replace /> },
                      ],
                  },
              ]
    );
